import React from 'react';

const GallerySection = () => {
  return (
    <section className="py-24 bg-[#1a1c1b] border-t border-[var(--border-light)]">
      <div className="container-custom mx-auto px-6">
        <div className="mb-16">
          <h2 className="heading-2 mb-4">Narratives That Turn Uncertainty into Momentum</h2>
          <div className="h-1 w-20 bg-[var(--brand-primary)]"></div>
        </div>

        {/* Single Featured Image Layout */}
        <div className="w-full h-[600px] relative group overflow-hidden rounded-2xl border border-[var(--border-medium)]">
            <img 
                src="https://customer-assets.emergentagent.com/job_speak-delivery/artifacts/khotlsg8_shc%2011.jpg" 
                alt="Keynote Speaking Event" 
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end items-start p-12">
                <p className="text-[var(--brand-primary)] font-display uppercase text-4xl mb-2">Keynote Speaker</p>
                <p className="text-white font-display uppercase text-2xl tracking-widest">Now New Next</p>
            </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
